import { useState, useCallback } from 'react';

type UseControllableOpenProps = {
  isOpen?: boolean;
  onOpen?: () => void;
  onClose?: () => void;
};

export const useControllableOpen = ({
  isOpen: isOpenProp,
  onOpen: onOpenProp,
  onClose: onCloseProp,
}: UseControllableOpenProps) => {
  const isOpenControlled = isOpenProp !== undefined;
  const [internalIsOpen, setInternalIsOpen] = useState(false);

  // In controlled mode, either the parent OR internal state can open the
  // menu — a non-responsive parent (e.g. annotation system with no
  // annotations) won't block user interaction.
  const isOpen = isOpenControlled
    ? isOpenProp || internalIsOpen
    : internalIsOpen;

  const handleOpen = useCallback(() => {
    setInternalIsOpen(true);
    onOpenProp?.();
  }, [onOpenProp]);

  const handleClose = useCallback(() => {
    setInternalIsOpen(false);
    onCloseProp?.();
  }, [onCloseProp]);

  return { isOpen, isOpenControlled, handleOpen, handleClose };
};
